import Section from '../../../elements/Section'
import Container from '../../../elements/Container'
import Columns from '../../../layout/Columns'
import Column from '../../../layout/Column'
import LazyImage from '../../../elements/LazyImage'
import styles from './styles.module.scss'
import { useResponsive } from '../../../../providers/ResponsiveContext'
import { withModifiers } from '../../../helpers/withModifiers'
import isEmpty from 'lodash-es/isEmpty'
import { getS3Url } from '../../../helpers/getS3Url'
import Perk from '../../single-property/components/Perk'

import { useState, useEffect } from 'react'

const Promo = ({ content = false }) => {
  const { isDesktop, isSmallMobile } = useResponsive()
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(true)
  }, [])

  if (!content) {
    return
  }

  if (content && !isEmpty(content) && loaded) {
    return (
      <Section variant={['gray']}>
        <Container>
          {content.map((column, index) => {
            const isFirstColumn = index === 0

            return (
              <Columns
                key={`promo-column-${index}`}
                variant={[
                  isFirstColumn ? '-distribute-between' : '-align-end',
                  !isDesktop && '-align-middle'
                ]}
                className={styles.columns}
              >
                <Column
                  spans={
                    isFirstColumn
                      ? isSmallMobile
                        ? 12
                        : 5
                      : isSmallMobile
                      ? 12
                      : isDesktop
                      ? 6
                      : 7
                  }
                >
                  <div
                    className={withModifiers(
                      'image',
                      [!isFirstColumn && 'second'],
                      styles
                    )}
                  >
                    <LazyImage
                      src={getS3Url(column.cloudflare_picture)}
                      layout="fill"
                      objectFit="cover"
                      objectPosition="center"
                    />
                  </div>
                </Column>

                <Column
                  className={styles.column}
                  spans={
                    isFirstColumn
                      ? isSmallMobile
                        ? 12
                        : isDesktop
                        ? 7
                        : 6
                      : isSmallMobile
                      ? 12
                      : isDesktop
                      ? 5
                      : 4
                  }
                >
                  {column.content ? (
                    column.content.map((item, index) => {
                      switch (item.type) {
                        case 'Title':
                          return (
                            <h2 key={`title-${index}`} className={styles.title}>
                              {item.data.title}
                            </h2>
                          )

                        case 'Description':
                          return (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.data.description
                              }}
                              key={`description-${index}`}
                            ></div>
                          )
                        case 'Statistics':
                          return item.data.map((perk, index) => (
                            <Perk
                              icon={perk.cloudflare_icon}
                              key={`column-perk-${index}`}
                              title={perk.title}
                              value={perk.value}
                            />
                          ))
                      }
                    })
                  ) : (
                    <>
                      <h2 className={styles.title}>{column.title}</h2>

                      <div
                        angerouslySetInnerHTML={{
                          __html: column.description
                        }}
                      ></div>
                    </>
                  )}
                </Column>
              </Columns>
            )
          })}
        </Container>
      </Section>
    )
  }

  return
}

export default Promo
